// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"18d31d91","977":"4305234f"}[chunkId] + ".chunk.js";
};